import LazyLoad from "vanilla-lazyload";

const lazyLoadOptions = {
    data_src: "original",
    threshold: (document.getElementById("hdLazyLoad")) ? document.getElementById("hdLazyLoad").value : '50',
    callback_loaded: element => {
        //console.log("LOADED", element);
        let imageWrapper = element.closest(".image-wrapper");
        if (imageWrapper) {
            let containerHeight = imageWrapper.offsetHeight;

            if (element.offsetHeight > containerHeight) {
                imageWrapper.style.height = element.offsetHeight + 'px';
            }
        }
    }
};

const lazyMenuImages = {
    data_src: "original",
    elements_selector: ".lazyMenu",
    threshold: (document.getElementById("hdLazyLoad")) ? document.getElementById("hdLazyLoad").value : '50',
};

window.lazyLoadBackground = new LazyLoad({
    data_bg: "bg",
});

const createLazyLoadInstances = () => {
    
    return (
        new LazyLoad(lazyLoadOptions),
        new LazyLoad(lazyMenuImages),
        window.lazyLoadBackground
    );
};

export default () => {
    document.addEventListener("DOMContentLoaded", createLazyLoadInstances);
};